"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.handleScroll = handleScroll;
exports.isStickyAtPosition = isStickyAtPosition;
var _feature = require("../feature");
/**
 * Checks if a sticky element is at the specified position of its container.
 *
 * @param {HTMLElement} stickyElement - The sticky element to check.
 * @param {HTMLElement} containerElement - The container of the sticky element.
 * @param {string} position - The position to check. Can be either 'top' or 'bottom'.
 * @param {number} offset - The offset from the top or bottom of the container. Default is 0.
 * @returns {boolean} - Returns true if the sticky element is at the specified position of its container, false otherwise.
 */
function isStickyAtPosition(stickyElement, containerElement, position, offset = 0) {
  const stickyRect = stickyElement.getBoundingClientRect();
  const containerRect = containerElement.getBoundingClientRect();
  if (!containerRect || !stickyRect) {
    return false;
  }
  if (position === 'top') {
    return stickyRect.bottom <= containerRect.top - offset;
  }
  return stickyRect.bottom >= containerRect.bottom - offset;
}

/**
 * Adds a 'scroll' event listener to the window that checks if a sticky element is at the specified position of its container.
 * Calls a callback function with the result.
 *
 * @param {HTMLElement} stickyElement - The sticky element to check.
 * @param {HTMLElement} containerElement - The container of the sticky element.
 * @param {string} position - The position to check. Can be either 'top' or 'bottom'.
 * @param {function} callback - The callback function to call with the result.
 * @param {number} offset - The offset from the top or bottom of the container. Default is 0.
 * @returns {function} A function that removes the event listener.
 */
function handleScroll(stickyElement, containerElement, position, callback, offset = 0) {
  const scrollHandler = () => {
    const result = isStickyAtPosition(stickyElement, containerElement, position, offset);
    callback(result);
  };
  const scrollContainer = (0, _feature.ifFeature)('encore', document.getElementById('js-GlobalScrollContainer'), window); // TODO: Replace with getScrollContainer() once SrollManager is updated.
  if (!scrollContainer) {
    console.error(`No scroll container found.`);
    return () => undefined;
  }
  scrollContainer.addEventListener('scroll', scrollHandler);
  return () => {
    scrollContainer.removeEventListener('scroll', scrollHandler);
  };
}